import useGetQueueConfig from "../../apis/tryst/get-queue-config";
import useBillingStore from "../../stores/billing-store/billing-store";
import { isDoctorOnly } from "../../utils/bridges/methods";

const SetupDiv = () => {
  const { setShowCounterPopup } = useBillingStore();

  if (!isDoctorOnly()) {
    return <div className="text-13 font-400 leading-5 select-text">{"--"}</div>;
  }

  return (
    <div
      className="border border-darwin-primary-500 text-darwin-primary-500 text-13 font-700 leading-5 px-18 py-7 rounded-2 cursor-pointer"
      onClick={() => {
        setShowCounterPopup(true);
      }}
    >
      Set up
    </div>
  );
};

const ReceiptNumberField = ({
  receiptNumber,
  isFirst = false,
}: {
  receiptNumber: string;
  isFirst?: boolean;
}) => {
  const { data: queueConfigData, isLoading } = useGetQueueConfig();

  const { clinicId } = useBillingStore();

  const { data } = queueConfigData || {};
  const { receipt_counter } = data || {};

  const hasCounterForClinic = !!receipt_counter?.find(
    (counter) => counter.clinic_id === clinicId
  );

  if (receiptNumber) {
    return (
      <div className="text-13 font-400 leading-5 select-text">
        {receiptNumber}
      </div>
    );
  }

  if (hasCounterForClinic && !isLoading) {
    return <div className="text-13 font-400 leading-5">Not Created</div>;
  }

  if (!hasCounterForClinic && isFirst && !isLoading) {
    return <SetupDiv />;
  }

  if (isLoading) {
    return <div>--</div>;
  }

  return <div>Not Setup</div>;
};

export default ReceiptNumberField;
